import { forwardRef } from 'react'

import { Polymorphic } from '../../../utils/PolymorphicUtils'

export type FooterContactImageProps = {
  name: string
  image: string
}

export const FooterContactImage = forwardRef(function FooterContactImage(
  { as: Component = 'div', name, image, ...props },
  ref,
) {
  return (
    <Component
      className="relative basis-2/12 max-w-40 md:max-w-none"
      {...props}
      ref={ref}
    >
      <div className="absolute -inset-2 rounded-3xl border border-neon-500/30 opacity-70 blur-[10px]" />
      <img
        alt={name}
        className="relative h-full rounded-2xl border border-ink-200/70 object-cover shadow-lg  dark:border-ink-700/70"
        src={image}
      />
    </Component>
  )
}) as Polymorphic<'div', FooterContactImageProps>
